// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4693e5d8","732":"0bb0f63d","977":"15685fb2"}[chunkId] + ".chunk.js";
};